module.exports = __webpack_public_path__ + "97b70f4d9bcb20b87c9ab700593b6eb1.svg";